import axios from 'axios';
import { backendBaseUrl5 } from './config';
import { BackendError } from './shared';

const highscoresApi = axios.create({
    baseURL: `${backendBaseUrl5}highscore/`,
});

export function getHighscores(gametoken) {
    return new Promise((resolve, reject) => {
        const params = { gametoken };
        highscoresApi
            .get('PageLoad', { params })
            .then((axResult) => {
                if (axResult?.data?.responsecode === 0) {
                    resolve(axResult.data.data);
                } else if (axResult?.data?.responsemsg) {
                    reject(new BackendError(axResult.data.responsemsg));
                } else {
                    reject(new Error(`getHighscores error`));
                }
            })
            .catch((axiosError) => {
                // console.log('axiosError:', axiosError);
                reject(JSON.stringify(axiosError, 4));
            });
    });
}
